
import {Enum} from '../../common/model/enum.model';

export class TipoRuolo extends Enum {

  constructor(protected value: string) {
    super(value);
  }

  public static values(): TipoRuolo[] {
    return [
      new TipoRuolo('ROLE_ADMIN'),
      new TipoRuolo('ROLE_USER'),
      new TipoRuolo('ROLE_SUPERUSER'),
      new TipoRuolo('ROLE_ANONYMOUS'),
      new TipoRuolo('ROLE_GENERIC'),
      new TipoRuolo('MANAGER_CONTESTO'),
      new TipoRuolo('GESTORE_CONTESTO'),
      new TipoRuolo('ROLE_GROUP')
    ];
  }

  public isRuoloGenerico(): boolean {
    return this.getEnumValue()=='ROLE_GENERIC';
  }

  public isRuoloApplicativo(): boolean {
    return this.getEnumValue()=='ROLE_ADMIN' ||
           this.getEnumValue()=='ROLE_USER' ||
           this.getEnumValue()=='ROLE_SUPERUSER' ||
           this.getEnumValue()=='ROLE_ANONYMOUS';
  }

  public isManagerContesto(): boolean {
    return this.getEnumValue()=='MANAGER_CONTESTO';
  }

  public isGestoreContesto(): boolean {
    return this.getEnumValue()=='GESTORE_CONTESTO';
  }

  public isTipoGruppo(): boolean {
    return this.getEnumValue()=='ROLE_GROUP';
  }
}
